import { odooCrm } from 'api/config'

export const createOdooContact = (body) => {
  return odooCrm.post(`/contacts`, body)
}
